import { cn } from '../lib/cn';

import { LoadingStatus } from './spinner';

import type { HTMLAttributes } from 'react';

export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div aria-hidden="true" className={cn('ui-skeleton rounded-md', className)} {...props} />;
}

/** Keeps the page footprint stable while its first response is pending. */
export function PageSkeleton({
  label = 'Loading activities…',
  reader = false,
}: {
  label?: string;
  reader?: boolean;
}) {
  return (
    <div
      className={cn(
        'mx-auto w-full space-y-7 p-6 sm:p-8',
        reader ? 'max-w-[800px]' : 'max-w-[1120px]',
      )}
    >
      <LoadingStatus label={label} />
      <div className="space-y-3">
        <Skeleton className="h-8 w-2/3" />
        <Skeleton className="h-4 w-1/2" />
      </div>
      <div className={cn('grid gap-4', !reader && 'sm:grid-cols-[2fr_1fr]')}>
        <Skeleton className="h-44" />
        {!reader ? <Skeleton className="h-44" /> : null}
      </div>
      {[0, 1, 2].map((n) => (
        <div key={n} className="border-line flex gap-4 border-b pb-5">
          <Skeleton className="size-10" />
          <div className="flex-1 space-y-3">
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
}
